module.exports = __webpack_public_path__ + "static/oath_of_glory-5468931dad5a354903efc38441c95f08.png";